import React, { useState } from 'react';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js";
import ParadigmaDatePicker from "../../../components/ParadigmaDatePicker/ParadigmaDatePicker.js";
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";
import api from "../../../api";
import moment from 'moment';


const createInitialForm = () => ({
    old: moment(),
    new: moment(),
    motivo: '',
    errors: {},
})

const Modal = (props) =>  {

    const [form, setForm] = useState(createInitialForm());
    const fieldClassNames = ["ui-field-label-col", "ui-field-control-col"];

    const getData = () =>  {
        return {
            old: form.old.format('YYYY-MM-DD hh:mm:ss'),
            new: form.new.format('YYYY-MM-DD hh:mm:ss'),
            motivo: form.motivo ? form.motivo : '',
        }
    }

    const setInput = (k,v) => {
        let errors = form.errors;
        if (errors) delete errors[k];
        setForm({
            ...form,
            [k]: v,
            errors: errors
        })
    }
    const onValidation = () => {
        let err = {}
        let validate = true
        if (!form.motivo){
            err.motivo = [{ detail: "El campo 'motivo' no puede estar en blanco." }]
            validate = false
        }
        setForm({...form, errors: err})
        return validate
    }
    const getError = (field) => {
        let errors = form.errors;
        if (errors) return errors[field];
    }
    return(
        <ParadigmaModal
            getUrl={null}
            submitUrl={api.configuracion.vencimiento}
            submitType="POST"
            onValidation={()=>onValidation()}
            onGotErrors={(errors) => setForm(prevForm => ({ ...prevForm, errors }))}
            onClose={() => setForm(createInitialForm())}
            onPreSubmit={getData}
            title="Cambiar Fecha de Vencimiento"
            successMessage="Las Fechas han sido editadas con éxito."
            missingIdMessage="Debe seleccionar una fila."
            saveButtonLabel="Guardar"
            buttonTitle="Editar"
            buttonIcon="fa fa-pencil fa-lg"
            saveButton={true}
            closeButton={true}
            navButton
            nav={props.nav}
            className="ui-paradigma-modal"
        >
            <section className="ui-modal-section">
                <p className="ui-section-label">Vencimiento de cuotas</p>
                <div className="ui-form-grid">
                    <ParadigmaLabeledInput
                        label="De"
                        md={[12, 12]}
                        classNames={fieldClassNames}
                        inputComponent={
                            <ParadigmaDatePicker
                                fieldName={"fechaInicio"}
                                datetime={false}
                                icon={"fa fa-calendar"}
                                value={form.old}
                                onChange={data => setInput('old', data)}
                            />
                        }
                    />
                    <ParadigmaLabeledInput
                        label="A"
                        md={[12, 12]}
                        classNames={fieldClassNames}
                        inputComponent={
                            <ParadigmaDatePicker
                                fieldName={"fechaFin"}
                                datetime={false}
                                icon={"fa fa-calendar"}
                                defaultValue={null}
                                value={form.new}
                                onChange={data => setInput('new', data)}
                            />
                        }
                    />
                    <div className="ui-span-2">
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Motivo"}
                            type="textarea"
                            rows={4}
                            value={form.motivo}
                            onChange={e => setInput('motivo', e.target.value)}
                            error={() => getError('motivo')}
                        />
                    </div>
                </div>
            </section>
        </ParadigmaModal>
    );
    
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Configuracion/CambiarVencimiento/CambiarVencimiento.js